import { styled } from "@mui/material";

export const ControlsContainer = styled("div")({
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  zIndex: 999,
  padding: "0 16px",
});

export const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",
});